<template>
      <q-select :style="{width: width + 'px'}"
        dense rounded outlined 
        v-model="habitat" 
        ref="habitatSelect"
        :options="habitatOptions" 
        :label="label" 
        option-value="value"
        option-label="label"
        @input="habSelect"
      >
        <template v-slot:option="scope">
          <q-item
            v-if="scope.opt.header"
            :key="'header-' + scope.index"
            class="q-pa-none"
          >
            <q-item-section>
              <q-item-label header class="header-style">{{ scope.opt.label }}</q-item-label>
            </q-item-section>
          </q-item>
          <q-item
            v-else
            :key="'option-' + scope.index"
            clickable
            @click="habSelect(scope.opt)"
          >
            <q-item-section>
              <q-item-label>{{ scope.opt.label }}</q-item-label>
            </q-item-section>
          </q-item>
        </template>
      </q-select>

</template>
<script setup lang="ts">
import { ref, toRefs, computed } from "vue";
import { useRouter } from 'vue-router';
import { useMapItems } from "../composables/useMapItems"
import { useHelpers } from "../composables/useHelpers"
const props = defineProps({
    width: {type: Number, default:260},
    label: {type: String, default: "Spotlight a Habitat"}
})
const { width, label } = toRefs(props)
const router = useRouter();
const { setActiveHabSpotlight, setProcessedData, clearMapStyle, activeHabSpotlight } = useMapItems()
const { arrayFindObjectByProp, logGAevent }= useHelpers()


const habitat = computed (() =>{
  if (activeHabSpotlight.value == null){
    return null
  }
  else{
    return arrayFindObjectByProp(habitatOptions.value, "value", activeHabSpotlight.value)
  }
});
const habitatOptions = ref([
  // {header: true, label: 'Coastal'},
  {label: "Wetlands", value: "wetlands"},
  {label: "Rocky Intertidal", value: "rocky"},
  {label: "SAV / eelgrass", value: "sav"},
  {label: "Coastal / Barrier Islands", value: "barrierIslands"},
  {label: "Sand / dunes", value: "sand"},
  {label: "Small Islands", value: "smallIslands"},
  {label: "Estuaries", value: "estu"},
  // {header: true, label: 'Offshore'},
  // {label: "Canyons", value: "canyons"},
  // {label: "Banks ", value: "banks"},
])
const habitatSelect = ref(null);

const habSelect = (opt) =>{
  logGAevent('hab_spotlight', opt.value, "")
  clearMapStyle()
  // console.log(opt.value)
  // habitat.value = opt;
  habitatSelect.value.hidePopup();
  setActiveHabSpotlight(opt.value)
  router.push({
    path:'/habSpotlight'
  })
  setProcessedData('habSpotlight', opt.value)
}

</script>
<style>
.header-style {
  font-weight: bold;
  font-size: 1.2em;
  text-decoration: underline;
  color: #000000;
  background-color: #e0e0e0;
  padding: 8px;
}</style>